// extracted by mini-css-extract-plugin
export default {"rating":"vG-z","numberOfStars":"wG-z","count":"xG-z","barGraphSpacing":"yG-z","barGraph":"zG-z"};